var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyFeedbackActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6805 10.9047C22.6805 16.897 17.8228 21.7547 11.8305 21.7547C5.83818 21.7547 0.980469 16.897 0.980469 10.9047C0.980469 4.9124 5.83818 0.0546875 11.8305 0.0546875C17.8228 0.0546875 22.6805 4.9124 22.6805 10.9047Z",
    fill: "#0f62fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48063 14.3118C8.48063 13.8974 8.81659 13.5615 9.23101 13.5615H15.234C15.6484 13.5615 15.9844 13.8974 15.9844 14.3118C15.9844 14.7263 15.6484 15.0622 15.234 15.0622H9.2314C8.81698 15.0622 8.48063 14.7263 8.48063 14.3118Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03679 9.87954C8.23591 10.0147 8.4528 10.0822 8.68748 10.0822C8.92216 10.0822 9.1355 10.0147 9.32751 9.87954C9.52663 9.73731 9.68663 9.55242 9.80753 9.32485C9.92842 9.09017 9.98887 8.83772 9.98887 8.56749C9.98887 8.28303 9.92842 8.02702 9.80753 7.79945C9.68663 7.57189 9.52663 7.39055 9.32751 7.25543C9.1355 7.1132 8.92216 7.04209 8.68748 7.04209C8.4528 7.04209 8.23591 7.1132 8.03679 7.25543C7.84478 7.39055 7.68833 7.57189 7.56743 7.79945C7.45365 8.02702 7.39676 8.28303 7.39676 8.56749C7.39676 8.83772 7.45365 9.09017 7.56743 9.32485C7.68833 9.55242 7.84478 9.73731 8.03679 9.87954Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3304 9.87954C14.5295 10.0147 14.7464 10.0822 14.9811 10.0822C15.2229 10.0822 15.4398 10.0147 15.6318 9.87954C15.8238 9.73731 15.9767 9.55242 16.0905 9.32485C16.2113 9.09017 16.2718 8.83772 16.2718 8.56749C16.2718 8.29014 16.2113 8.03769 16.0905 7.81012C15.9767 7.57544 15.8238 7.39055 15.6318 7.25543C15.4398 7.1132 15.2229 7.04209 14.9811 7.04209C14.7464 7.04209 14.5295 7.1132 14.3304 7.25543C14.1313 7.39055 13.9713 7.57544 13.8504 7.81012C13.7366 8.03769 13.6797 8.29014 13.6797 8.56749C13.6797 8.83772 13.7366 9.09017 13.8504 9.32485C13.9713 9.55242 14.1313 9.73731 14.3304 9.87954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyFeedbackActive);
export default __webpack_public_path__ + "static/media/partly-feedback-active.c9b051e29106284bdd420536c59a810b.svg";
export { ForwardRef as ReactComponent };